export enum UserRole {
  DEALER = 'dealer',
  PLAYER = 'player',
  OBSERVER = 'observer'
}